import { render, staticRenderFns } from "./DriverPhotosList.vue?vue&type=template&id=35f5f45c&scoped=true&"
import script from "./DriverPhotosList.vue?vue&type=script&lang=js&"
export * from "./DriverPhotosList.vue?vue&type=script&lang=js&"
import style0 from "./DriverPhotosList.vue?vue&type=style&index=0&id=35f5f45c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f5f45c",
  null
  
)

export default component.exports